import styled, { keyframes, css } from 'styled-components';

const cubicBezier = `cubic-bezier(0.23, 1, 0.32, 1)`;

const showSnowflake = keyframes`
  0%          { opacity: 0; }
  100%        { opacity: 1; }
`;

const fadeInSnowflake = css`
  animation: ${showSnowflake} 0.5s ${cubicBezier} 0s forwards;
`;

export const DesktopSidebarWithSnowflakeWrapper = styled('section')`
  position: fixed;
  top: 80px;
  width: ${({ theme }) => theme.sidebarWidth}px;
  padding: ${({ theme }) => `${theme.x1spacePx}px ${theme.x3spacePx}px 0 0`};
`;

export const DesktopSidebarWrapper = styled('div')`
  position: fixed;
  top: 375px;
`;

interface ToggleProps {
  animate?: boolean;
}

export const ToggleWrapper = styled('div')<ToggleProps>`
  ${({ animate }) => animate && fadeInSnowflake}
`;

export const ToggleSnowflake = styled('div')<ToggleProps>`
  padding-bottom: 25px;
  ${({ animate }) => animate && fadeInSnowflake}
`;
